import React, { createContext, useMemo, useState } from 'react';
import { enUS, fr } from 'date-fns/locale';

const languageDefault = "en-US";

const localeDefault = enUS;
const localeMap = { fr };

const placeholderDefault = "MM/DD/YYYY";
const placeholderMap = {
    fr: { year: "AAAA", month: "MM", day: "JJ" },
};

/**
 * Context
 */
const LocaleContext = createContext({
    locale: localeDefault,
    dateOfBirthPlaceholder: placeholderDefault,
    setLanguage: () => {},
});

/**
 * Provider, used to get the appropriate browser's language's placeholder
 */
function LocaleProvider({ children }) {

    const [language, setLanguage] = useState(() => navigator.language || languageDefault);

    // Get a date placeholder string, based on the current language
    const { locale, dateOfBirthPlaceholder } = useMemo(() => {
        const lang = language?.split('-')[0].toLowerCase();
        const locale = localeMap[lang] || localeDefault;

        const placeholders = placeholderMap[lang];
        if (!placeholders) {
            return { locale, dateOfBirthPlaceholder: placeholderDefault };
        }

        try {
            const formatter = new Intl.DateTimeFormat(language);
            let parts = formatter.formatToParts(new Date());

            const dateOfBirthPlaceholder = parts.map(part => {
                switch (part.type) {
                    case "year": return placeholders.year;
                    case "month": return placeholders.month;
                    case "day": return placeholders.day;
                    default: return part.value;
                }
            })
            .join("");
            return { locale, dateOfBirthPlaceholder };
        } catch (error) {
            console.error("Error formatting placeholder:", error);
            return { locale, dateOfBirthPlaceholder: placeholderDefault };
        }
    }, [language]);

    return (
        <LocaleContext.Provider value={{ locale, dateOfBirthPlaceholder, setLanguage }}>
            {children}
        </LocaleContext.Provider>
    );
}

export { LocaleContext, LocaleProvider };